import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable} from 'rxjs';
import {environment} from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ContractShareService {

  constructor(
    public _http: HttpClient
  ) {

  }

  consultarSocio(request: any): Observable<any> {
    let ruta = environment.catShareConsultaSocio;
    let params = JSON.stringify(request);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.post(ruta, params, { headers: headersResp });
  }

  catShare(request: any) {
    let ruta = environment.catShare;
    let params = JSON.stringify(request);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.post(ruta, params, { headers: headersResp });
  }

  catShareUpdate(request: any) {
    let ruta = environment.catShare;
    let params = JSON.stringify(request);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.put(ruta, params, { headers: headersResp });
  }

  cargaMasivaCatShare(request: any){
    let ruta = environment.cargaMasivaCatShare;
    let params = JSON.stringify(request);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.post(ruta, params, { headers: headersResp });
  }

  deleteContract(accion : any){
    let ruta = environment.deleteAccion;
    let params = JSON.stringify(accion);
    let headersResp = new HttpHeaders().set('Content-Type', 'application/json');
    let config = {
      body: params,
      headers: headersResp

   };
    return this._http.delete(ruta,config);
  }

  getInfoCierreSemanal(data: any){
    let ruta = environment.getInfoCierreSem;
    return this._http.get(ruta + data.partnerId + '/' + data.year + '/' + data.week);
  }

}
